import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import StaffPage from "@/pages/Staff";
import StaffDetail from "@/pages/StaffDetail";
import AlertsPage from "@/pages/Alerts";
import ReportsPage from "@/pages/Reports";
import SettingsPage from "@/pages/Settings";
import Onboarding from "@/pages/Onboarding";
import ImportPage from "@/pages/Import";
import ImportHistory from "@/pages/ImportHistory";
import Pricing from "@/pages/Pricing";
import PublicBadge from "@/pages/PublicBadge";
import Executive from "@/pages/Executive";
import Verifications from "@/pages/Verifications";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/o/:slug" element={<PublicBadge />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/executive" element={<Executive />} />
        <Route path="/staff" element={<StaffPage />} />
        <Route path="/staff/:id" element={<StaffDetail />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/verifications" element={<Verifications />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/import/history" element={<ImportHistory />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
